import React from "react";
import { useWorker } from "../context/WorkerContext";
import MyReferralsContent from "./MyReferralsContent";

// Mounted only under WorkerLayout, so useWorker() is always safe here.
const MyReferrals = () => {
  const { token, user } = useWorker();
  const userId = user?.id || user?._id;

  return <MyReferralsContent token={token} userId={userId} workerType="worker" />;
};

export default MyReferrals;


